// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiMenuItem-root {
  font-weight: bold !important;
}

.MuiTableCell-root {
  border: groove;
  border-width: 3px;
}

.MuiTableRow-root:nth-child(odd) {
  background-color: #f3f2f2;
}

.makeStyles-active-55 {
  border-radius: 0 6px 6px 0 !important;
  /* Yeni stil eklenebilir */
  background-color: #e4e4e4 !important;
  /* Aktif stil için metin rengi */
  color: #c80c0f !important;
  /* Metin rengini ayarlayın */
  border-left: 4px solid #c80c0f !important;
  /* Mevcut stil korundu */
}

.makeStyles-active-55 {
  border-radius: 0 6px 6px 0 !important;
  /* Yeni stil eklenebilir */
  background: #e4e4e4 !important;
  /* Arka plan rengini değiştirin */
  color: #c80c0f !important;
  /* Metin rengini ayarlayın */
  border-left: 4px solid #c80c0f !important;
  /* Mevcut stil korundu */
}

/* Aktif menü öğesindeki ikonun stilini değiştirin */
.makeStyles-active-55 .MuiListItemIcon-root {
  color: #c80c0f !important;
  /* İkonun rengi */
}
#react-admin-title {
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e4e4e4;
  color: #c80c0f !important;
  font-weight: bold !important;
  font-size: 20px !important;
  border-radius: 15px;
  margin: 5px !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;EAC5B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;EAC5B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".MuiMenuItem-root {\n  font-weight: bold !important;\n}\n\n.MuiTableCell-root {\n  border: groove;\n  border-width: 3px;\n}\n\n.MuiTableRow-root:nth-child(odd) {\n  background-color: #f3f2f2;\n}\n\n.makeStyles-active-55 {\n  border-radius: 0 6px 6px 0 !important;\n  /* Yeni stil eklenebilir */\n  background-color: #e4e4e4 !important;\n  /* Aktif stil için metin rengi */\n  color: #c80c0f !important;\n  /* Metin rengini ayarlayın */\n  border-left: 4px solid #c80c0f !important;\n  /* Mevcut stil korundu */\n}\n\n.makeStyles-active-55 {\n  border-radius: 0 6px 6px 0 !important;\n  /* Yeni stil eklenebilir */\n  background: #e4e4e4 !important;\n  /* Arka plan rengini değiştirin */\n  color: #c80c0f !important;\n  /* Metin rengini ayarlayın */\n  border-left: 4px solid #c80c0f !important;\n  /* Mevcut stil korundu */\n}\n\n/* Aktif menü öğesindeki ikonun stilini değiştirin */\n.makeStyles-active-55 .MuiListItemIcon-root {\n  color: #c80c0f !important;\n  /* İkonun rengi */\n}\n#react-admin-title {\n  padding: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #e4e4e4;\n  color: #c80c0f !important;\n  font-weight: bold !important;\n  font-size: 20px !important;\n  border-radius: 15px;\n  margin: 5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
